<template>
  <!-- <b-container class="card-container"> -->
    <b-card>
      <template v-slot:header class="card-menu">
        <span class="breadcrumbs"><b-link :to="{name: `project`}">Videos</b-link> / {{item ? item.name : ''}}</span>
        <b-button size="sm" variant="secondary float-right" :to="{name: `${collection}_edit`, params: {from_item: item}}" >Edit</b-button>
        <b-button v-if="profile.role === 'admin'" size="sm" variant="warning" class="float-right mr-2" @click="mark_as_error">Error</b-button>
        <b-button v-if="profile.role === 'admin' && item && item.quality_control_status !== 'pass'" size="sm" variant="warning" class="float-right mr-2" @click="mark_as_pass">Pass</b-button>
        <b-button v-if="profile.role === 'admin'" size="sm" class="float-right mr-2" :href="`https://console.firebase.google.com/u/0/project/${config && config.firebase_config ? config.firebase_config.projectId : 'puppet-dev'}/firestore/data~2Fproject~2F${$route.params.id}~2Fitem~2F${$route.params.item}`" target="_blank"><i class="fas fa-database"></i></b-button>
      </template>

      <Loading v-if="item === undefined"/>
      <Error v-else-if="item === null" code="404"></Error>
      <div v-else>
        <b-row>
          <b-col>
            <PlayerItem :item='item' :replay='true' :debug='true' />
          </b-col>
          <b-col>
            <div v-if="!item.variables || item.variables.length == 0" >
              <h3>Script</h3>
              <pre class="mb-2">{{item.script}}</pre>
            </div>

            <div v-if="item.website" class="mb-2">
              <p><strong>Website:</strong> {{item.website}}</p>
            </div>

            <b-table-simple responsive bordered v-if="item.variables && item.variables.length > 0">
              <b-thead head-variant="light">
                <b-tr>
                  <b-th>Variable</b-th>
                  <b-th>Replace with</b-th>
                </b-tr>
              </b-thead>
              <b-tr v-for="(variable, index) in item.variables" v-bind:key="index">
                <b-td>{{variable.word}}</b-td>
                <b-td>{{variable.replace_with}}</b-td>
              </b-tr>
            </b-table-simple>

            <b-button v-b-toggle.collapse-1 variant="secondary" size='sm' class='mb-2'>Shareable link <i class='when-open far fa-angle-up' key="up"></i><i class='when-closed far fa-angle-down' key="down"></i></b-button>
            <b-collapse id="collapse-1" class="mb-2">
              <b-card>
                <p>Shareable thumbnail with link. Copy and paste into your email.</p>
                <p><a :href="item.video_player_url" target='_blank'><img :src="item.thumbnail_url || project.thumbnail_url" width='480' height="360"/></a></p>
                <b-button @click="copy_html_to_clipboard(code)" size="sm" class='d-inline-block'>Copy to clipboard</b-button>

              </b-card>
            </b-collapse>
          </b-col>
        </b-row>

        <div v-if="events && events.length > 0" class="mt-4">
          <h4>Analytics Events</h4>
          <p>A list of events from the shareable link</p>
          <b-table-simple responsive bordered small>
            <b-thead head-variant="light">
              <b-tr>
                <b-th>Time</b-th>
                <b-th>Event</b-th>
                <b-th>ID</b-th>
                <b-th>Location</b-th>
              </b-tr>
            </b-thead>
            <b-tr v-for="(event, index) in filtered_events" v-bind:key="index">
              <b-td>{{event.created | datetime}}</b-td>
              <b-td>{{event.type}}</b-td>
              <b-td><span v-if="event.visitor">{{event.visitor.name}}</span></b-td>
              <b-td><span v-if="event.visitor">{{event.visitor.city}}, {{event.visitor.country}}</span></b-td>
            </b-tr>
          </b-table-simple>
        </div>

      </div>
    </b-card>
  <!-- </b-container> -->
</template>

<script>
/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */

import { db } from '@/main.js'
import ItemMixin from "@/mixins/Item.js"
import PlayerItem from '@/components/PlayerItem.vue'

export default {
  metaInfo: {title: 'Item'},
  mixins: [ItemMixin],
  components: {PlayerItem},
  props: ['project'],
  firestore: function () {
    return {
      item: db.collection('project').doc(this.$route.params.id).collection(this.collection).doc(this.$route.params.item),
      events: db.collection('project').doc(this.$route.params.id).collection(this.collection).doc(this.$route.params.item).collection('event').orderBy('created', 'desc')
    }
  },
  data() {
    return {
      events: [],
      collection: 'item'
    }
  },
  computed: {
    filtered_events() {
      if (!this.events) {
        return []
      }

      return this.events.filter(e => e.type !== 'watch_time')
    },
    code() {
      return `<a href="${this.item.video_player_url}" target='_blank'><img src="${this.item.thumbnail_url || this.project.thumbnail_url}" width='480' height="360"/></a>`
    }
  },
  methods: {
    mark_as_error() {
      this.$firestoreRefs.item.update({updated: new Date(), status: 'error', error_message: 'Manually marked as error'})
    },
    mark_as_pass() {
      this.$firestoreRefs.item.update({updated: new Date(), quality_control_status: 'pass', quality_control_updated: new Date()})
    },
    copy_success() {
      this.$swal({title: 'Copied', text: 'Copied to clipboard', icon: 'success'})
    },
    copy_html_to_clipboard(str) {
      function listener(e) {
        e.clipboardData.setData("text/html", str);
        e.clipboardData.setData("text/plain", str);
        e.preventDefault();
      }
      document.addEventListener("copy", listener);
      document.execCommand("copy");
      document.removeEventListener("copy", listener);

      this.copy_success()
    }
  }
}
</script>

<style>
.breadcrumbs {
  padding: 0.25rem 0.5rem;
  line-height: 1.5;
  display: inline-block;
}

.when-open {
  display: inline-block;
}

.when-closed {
  display: none;
}

.collapsed > .when-open {
  display: none;
}

.collapsed > .when-closed {
  display: inline-block;
}

</style>
